<template>
    <div>

        <b-card class="chatter-list">

        <!-- Card header -->
        <template #header>
                <!-- TODO 파일 업로드 -->
                <b-row style="height:3em" v-if="columns.length < 1">
                <b-col cols="10" class="d-flex align-items-center justify-content-end" >
                    <b-form-group label-for="file-input" class="new-file-label h-100 w-100">
                        <b-form-file ref="file-input" id="file-input" name="file" v-model="templateFile"
                        placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"
                        class="new-file-input h-100"></b-form-file>
                    </b-form-group>
                </b-col>
                    <b-col class="d-flex align-items-center justify-content-end" cols="2">
                    <b-button @click="downloadTemplate" style="height:100%; width:70%; background-color: green; margin-right: 0.5em;">
                        Template
                    </b-button>
                    <b-button @click="getCustomTableMeta" style="height:100%; width:70%; margin-left: 0.5em;">
                        Show
                    </b-button>
                </b-col>
          </b-row>
            

            <div class="row align-items-center">
                <div v-if="title" class="col-xs" style="padding-right: 1.0416vw;">
                    <h3>{{ title }}</h3>
                </div>

                <div class="col" style="display: flex; justify-content: flex-end;">
                    <div class="btn-wrap">
                        <div class="btn-group-area align-items-center">
                            <b-button v-if="exportButton" variant="outline-secondary" class="btn btn-export">{{ exportButton }}
                            </b-button>
                        </div>
                        <b-button v-if="createButton" variant="outline-success" class="btn btn-primary small">{{ createButton }}
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
        <!-- /Card header -->

        <!-- Card body -->
        <template #default>
            <div style="position:relative">

                <!-- Spinner -->
                <loading :active="loading"/>
                <!-- /Spinner -->

                <!-- Filter -->
                <!-- <chatter-filter @reload="reloadChatterList" :isRefreshed="refresh" /> -->
                <!-- /Filter -->

                <!-- Table -->
                <div class="custom-table-container">
                    <table class="table table-hover custom-table">
                        <colgroup>
                            <col v-for="(column, index) in columns" :key="index" :width="getWidth(columnWidths[index])" />
                        </colgroup>

                        <thead>
                            <tr class="text-center table-dark">
                                <th v-for="column in columns" :key="column" class="chat-list-header">
                                    {{ column }}
                                </th>
                            </tr>
                        </thead>

                        <tbody v-if="dataList.length !== 0">
                            <tr v-for="(data, index) in dataList" :key="index"
                                style="cursor: pointer;">
                                <td v-for="(item, itemIndex) in data" :key="`${index}_${itemIndex}`" :style="getAlign(itemIndex)">
                                    {{ item }}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="11" style="text-align:center">결과가 없습니다.
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>
                <!-- Table -->
            </div>
        </template>
        <!-- Card body -->
    </b-card>
    </div>
</template>
<script>
export default {
    name: 'FlexibleTable',
    data() {
        return {
          loading: false,
          title: '',
          exportButton: '',
          createButton: '',
          columns: [],
          columnWidths: [],
          columnAlignList: [],
          dataList: '',
          templateFile: null,
          errorToastOptions: {
            title: `Notification`,
            toaster: "b-toaster-bottom-center",
            solid: true,
            appendToast: false,
            autoHideDelay: 4000,
            variant: "danger"
          }
        }
    },
    methods: {
      getCustomTableMeta() {
          // 파일정보 가져오기
          // 파일이 없으면 메세지 출력 후 리턴
          if (!this.templateFile) {
              this.$bvToast.toast("임포트할 파일을 올려주세요.", this.errorToastOptions);
              // console.log(this.importDevMethodologyFile);

              return;
          }

          // 임포트 API 호출 후 
          const params = new FormData()
          params.append("file", this.templateFile);

          try {
              this.loading = true;
              axios.post('chatter/getCustomTableMeta',
                  params,
                  {
                      headers: {
                          'Authorization': accessToken()
                      }
                  }
              ).then(response => {
                  const status = response.data.status;

                  if(status === "200") {
                      const body = response.data.body;

                      this.title = body.title;
                      this.exportButton = body.exportButton;
                      this.createButton = body.createButton;
                      this.columns = body.columns;
                      this.columnWidths = body.columnWidths;
                      this.columnAlignList = body.columnAlignList;
                      this.dataList = body.dataList;

                      this.templateFile = null;
                  } else {

                      this.$bvToast.toast(response.data.message, this.errorToastOptions);
                      this.templateFile = null;
                  }
              });
          } catch (e) {
              this.loading = false;
          } finally {
              this.loading = false;
          }
      },
      getWidth(value) {
        const width = Number(value);
        return (width * 100) + '%'
      },
      getAlign(index) {
        return {'text-align': this.columnAlignList[index]}
      },
      downloadTemplate() {
        try {
          axios.get("chatter/download/template/custom-view-template.xlsx", {
            responseType: 'blob',
            headers: { Authorization: accessToken() }
          }).then(response => {
            if (response.status === 200) {
              const url = URL.createObjectURL(response.data)

              const link = document.createElement('a');
              if (url) {
                link.href = url;
                link.download = `custom-view-template.xlsx`;
                link.click();
              }
            }
          })
        } catch (e) {
          console.log(e);
        }
      },  
    }
}
</script>
<style>
td {
  vertical-align: middle;
}

.unread-label {
  position: absolute;
  top: 30%;
  left: 40%;
  transform: translate(-50%, -50%) rotate(-15deg);
  color: red;
  opacity: 0.9;
  font-size: 0.4em;
}

.down-arrow-icon {
  transform: translate(-50%, -50%) rotate(180deg);
  margin-left: 1em;
}

.chat-list-header {
  user-select: none;
  /* 드래그 불가능 */
  cursor: pointer;
  /* 포커스 시 커서를 손가락 모양으로 설정 */
}

.tooltip .tooltip-inner {
  max-width: 1000px !important;
  white-space: pre-wrap !important;
  text-align: start;
}

.popover {
  max-width: 1000px !important;
}

#export .modal-dialog {
  padding: 0;
}

#export .modal-body {
  padding: 0;
}

/* excel export 팝업 */
.popup-export.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-export .modal-content {
  border-radius: 20px;
}

.popup-export .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

.popup-export .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-export#export .modal-body {
  padding: 1.041vw 2.666rem;
}

.popup-export label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-body .custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-export .btn-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  padding: 2.604vw 0 1.562vw;
}

.popup-export .btn-wrap .btn {
  border-color: transparent;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-export .btn-wrap .btn-primary.small {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
}

.popup-export .btn-wrap .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-primary.disabled,
.popup-export .btn-wrap .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-secondary.small {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.popup-export .btn-wrap .btn-secondary:hover {
  background-color: #565662;
}

.popup-export .btn-wrap .btn-secondary.disabled,
.popup-export .btn-wrap .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
</style>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-primary.small {
  width: 148px;
  height: 40px;
}

.btn-export {
  width: 100px;
  height: 40px;
  background-color: #168D4C;
  color: #fff;
  border-color: transparent;
}

.btn-export:hover {
  background-color: #006F2E;
  border-color: transparent;
}

.btn-export.disabled,
.btn-export:disabled {
  color: #62796D;
  background-color: #759483;
}

.btn.btn-line {
  position: relative;
  width: 135px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

.btn.btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

.btn.btn-line.disabled,
.btn.btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

.btn.btn-line.small {
  height: 40px;
  text-align: center;
}

.btn-refresh {
  height: auto;
  padding: 0;
}

/* 공통요소 */
.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* card 영역 */
.card {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  font-family: 'NanumGothic';
}

.card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  /* padding-bottom: max(2.666rem, 2.0833vw); */
}

/* today work 영역 */
.card.today-work-wrap .card-body {
  padding-bottom: max(2rem, 1.5625vw);
}

.work-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 1.333rem;
}

.work-wrap .work-progress .title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.533rem;
}

.work-wrap .work-progress .title-wrap .title {
  font-size: 18px;
  font-weight: 700;
}

.work-wrap .work-progress .title-wrap .rate {
  font-size: 14px;
  font-weight: 400;
  color: #06F;
}

.work-wrap .work-progress .title-wrap .rate span:first-child {
  font-weight: 700;
}

.work-wrap .work-progress .progress-bar {
  width: 17.3333rem;
  height: 26px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.10);
  background-color: #D8E7FF;
}

.work-wrap .work-progress .progress-bar .bar {
  height: 100%;
  background-color: #06F;
}

.work-wrap .work-progress {
  flex-grow: 0;
  flex-shrink: 1;
  margin-right: 60px;
}

.work-wrap .status-list-wrap {
  flex-shrink: 1;
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.333rem, auto));
  gap: 0.4rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.work-wrap .status-list-wrap .status-list {
  /* min-width: 140px; */
  height: 40px;
}

.work-wrap .status-list-wrap .status-list .status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 10px;
  min-width: 100%;
  height: 100%;
  padding: 0 0.466rem 0 0.8rem;
  border-radius: 34px;
  border: 1px solid #DDDDE3;
  background-color: #fff;
  font-size: 14px;
  color: #2E2E38;
}

.work-wrap .status-list-wrap .status-list:hover .status-item {
  border: 1px solid #2E2E38;
}

.work-wrap .status-list-wrap .status-list .status-item span {
  display: inline-block;
}

.work-wrap .status-list-wrap .status-list.bg-gray .status-item {
  border: 1px solid transparent;
  background-color: #E7E7EE;
}

.work-wrap .status-list-wrap .status-list.bg-gray:hover .status-item {
  background-color: #D4D4DC;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item {
  border: 1px solid transparent;
  background-color: #40404B;
  color: #fff;
}

.work-wrap .status-list-wrap .status-list.bg-bk:hover .status-item {
  background-color: #1B1B1B;
}

.work-wrap .status-list-wrap .status-item .status {
  font-weight: 500;
  line-height: 150%;
}

.work-wrap .status-list-wrap .status-item .num {
  height: 26px;
  padding: 0 0.5rem;
  border-radius: 30px;
  background-color: #fff;
  color: #2E2E38;
  text-align: center;
  line-height: 26px;
  font-weight: 700;
  font-size: 14px;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item .num {
  background-color: transparent;
  color: #fff;
}

/* chatter list 영역 */
.card.chatter-list {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card.chatter-list .card-header {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  padding-bottom: 1erm;
  border-radius: 30px 30px 0 0;
  border-bottom: none;
}

.card.chatter-list .card-header>div {
  flex-wrap: wrap;
  /* gap: 2rem; */
}

.card.chatter-list .card-header .title-wrap {
  display: flex;
  gap: 0 1.333rem;
}

.card.chatter-list .card-header h3 {
  display: flex;
  align-items: center;
  gap: 0 1.333rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.card.chatter-list .card-header h3>span {
  white-space: nowrap;
}

.card.chatter-list .card-header .btn-wrap {
  display: flex;
  gap: 0 2rem;
}

.card.chatter-list .card-header .btn-wrap .btn-group-area {
  position: relative;
  display: flex;
  gap: 0 0.666rem;
}

.card.chatter-list .card-header .btn-wrap .btn-group-area::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  right: -1rem;
  transform: translateY(-50%);
  width: 1px;
  height: calc(100% - 1.066rem);
  background-color: #DDDDE3;
}

/* my chatter list table 영역 */
.custom-table-container {
  margin-top: 1rem;
  padding: 0.666rem;
  border-radius: 20px;
  background-color: #F6F6FA;
}

.table.custom-table {
  margin-bottom: 0;
}

.table.custom-table tr {
  color: #2E2E38;
  background-color: #FFF;
}

.table.custom-table tr:hover {
  background-color: #FAFAFA;
}

.table.custom-table thead th,
.table-bordered.custom-table th {
  height: 70px;
  padding-top: calc(0.75rem - 0.666rem);
  background-color: #F6F6FA;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #C4C4CD;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  vertical-align: middle;
  white-space: nowrap;
}

.table.custom-table td {
  min-height: 80px;
  padding: 1.333rem 0.666vw;
  border-top: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  vertical-align: middle;
}

.table.custom-table td .title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table.custom-table td .title-wrap .title-container {
  flex-grow: 1;
}

.table.custom-table td .title-wrap .title-text {
  padding-left: 2.067rem;
  font-weight: 700 !important;
}

.table.custom-table td .title-wrap .chatter-hierarchy {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
  padding-left: 0.533rem;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn-subordinate {
  border: none;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  width: 36px;
  height: 36px;
  background-color: transparent;
  padding: 0;
}

.icon-arrow-subordinate {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background-color: transparent;
  padding: 0;
}

.btn-superior {
  display: inline-block;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background-color: transparent;
}

.table.custom-table tr:last-child td:first-child {
  border-radius: 0 0 0 10px;
}

.table.custom-table tr:last-child td:last-child {
  border-radius: 0 0 10px 0;
}

.table.custom-table .status-tag {
  display: inline-block;
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap
}

.table.custom-table .status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.table.custom-table .overdue .status-tag.in-progress {
  background-color: #F5D6D6;
  color: #F00;
}

.table.custom-table .status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.table.custom-table .status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.table.custom-table .status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.table.custom-table .status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}

.btn.updated {
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  color: #1755CC;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  opacity: 1;
}

.level-circle {
  display: inline-block;
  font-size: 6px;
  margin-left: 0.533rem;
  transform: translateY(-1.5px);
}

.unread-label {
  position: relative;
  top: unset;
  left: unset;
  transform: none;
  color: #F00;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  opacity: 1;
}

.assignee-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.729vw;
  width: 100%;
  white-space: nowrap;
}

.assignee-wrap .user-profile {
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}

.assignee-wrap .user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  object-fit: cover;
}

.assignee-wrap .user-today-off-img {
  position: absolute;
  width: 18px;
  height: 15px;
  transform: translate(165%, -120%);
}

.assignee-wrap .assignee-name {
  width: calc(100% - 40px - 0.729vw);
  max-width: 98px;
}

.assignee-wrap .assignee-day-off {
  font-size: 10px;
}

.btn-more-area {
  display: flex;
  justify-content: center;
  margin-top: 2.666rem;
}

.btn-more-area .btn-view-more {
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
  padding: 1.3rem 3.3rem 1.3rem 3.033rem;
  border-radius: 60px;
  background-color: #E7E7EE;
}

.btn-more-area .btn-view-more .icon {
  margin-top: -3px;
  margin-right: 0.533rem;
}

.btn-more-area .btn-view-more span {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  line-height: 150%;
}

.btn-more-area .btn-view-more:hover {
  background-color: #C4C4CD;
}

/* .btn-reset-img{
  width:25px;
  height:27px;
  margin: 0 10px 0 10px;

}
.btn-recent-img{
  width:30px;
  height:30px;
} */

.recent-button {
  display: flex;
  align-items: center;
  gap: 0 12px;
  padding: 8px 12px 8px 16px;
  border-radius: 40px;
  border: none;
  background-color: #E7E7EE;
  color:#2E2E38;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.recent-button:hover {
  background-color: #DDDDE3;
}

.recent-button .icon {
  display: block;
  width: 24px;
  height: 24px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M3 17H10" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 12H14" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 7H14" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 16L13 18L15 20" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.5556 14H18.7778C20.0051 14 21 14.8954 21 16C21 17.1046 20.0051 18 18.7778 18H14" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.refresh-button {
  display: flex;
  align-items: center;
  gap: 0 12px;
  padding: 8px 12px 8px 16px;
  border-radius: 40px;
  border: none;
  background-color: #2E2E38;
  color:#FFF;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.refresh-button .icon {
  display: block;
  width: 18px;
  height: 18px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13.5 13.5L4.5 4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 4.5L4.5 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.business-category-title {
  font-size:8pt;
}
</style>